// useGet.jsx 파일 전체 내용
import { useEffect, useState } from "react";
import { getValidToken } from "./api";

export default function useGet(fatchData) {
    const [data, setData] = useState({});

    useEffect(() => {
        const fetchDataAsync = async () => {
            if (!((fatchData.chk || fatchData.chk === undefined || fatchData.chk === null) && fatchData.url)) {
                return;
            }

            let storageToken = fatchData.loginType === "sessionLogin"
                ? sessionStorage.getItem("token")
                : localStorage.getItem("token");

            let headers = {
                'Accept': 'application/json'
            };

            // 방어 로직: 쓰레기값("null") 차단
            if ((fatchData.loginType === "login" || fatchData.loginType === "sessionLogin") &&
                storageToken && storageToken !== "null" && storageToken !== "undefined") {
                headers['Authorization'] = 'Bearer ' + storageToken;
            }

            let fetchOptions = {
                method: "GET",
                headers: headers
            };

            try {
                let response = await fetch(`${process.env.REACT_APP_API_URL}${fatchData.url}`, fetchOptions);

                // 401 만료 시: 토큰 매니저에게 새 열쇠를 부탁함
                if (response.status === 401) {
                    console.log("⚠️ [useGet] 만료 감지! 대기실을 통해 갱신 시도...");
                    try {
                        let newToken = await getValidToken(fatchData.loginType);

                        // 새 열쇠로 갈아끼우고 재요청!
                        fetchOptions.headers['Authorization'] = 'Bearer ' + newToken;
                        response = await fetch(`${process.env.REACT_APP_API_URL}${fatchData.url}`, fetchOptions);
                    } catch (refreshError) {
                        console.log("❌ [useGet] 갱신 최종 실패 -> 강제 로그아웃");
                        localStorage.removeItem("token");
                        localStorage.removeItem("refresh_token");

                        if (window.location.pathname !== '/member/login' && window.location.pathname !== '/member/find/password' && window.location.pathname !== '/set/password' && window.location.pathname !== '/member/pwSetting') {
                            if (window.errMsg) window.errMsg("인증이 만료되었습니다. 다시 로그인해주세요.");
                            window.location.href = `/member/login`;
                        }
                        return;
                    }
                }

                // 일반 에러 처리
                if (response.status !== 200 && response.status !== 401) {
                    window.location.href = `/pageErr/${response.status}`;
                    return;
                }

                let fetchRd = await response.json();
                setData(fetchRd);

            } catch (error) {
                console.error("useGet 통신 에러:", error);
            }
        };

        fetchDataAsync();

    }, [fatchData.url, fatchData.mutate, fatchData.chk, fatchData.loginType]);

    return data;
}